import script from "./PageTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTopbar.vue?vue&type=script&setup=true&lang=js"

import "./PageTopbar.vue?vue&type=style&index=0&id=d313b0e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d313b0e2"]])

export default __exports__